import type { SportsEventTypeInfoState } from './types';

export const defaultState: SportsEventTypeInfoState = {
  isLoading: false,
  hasPreloaded: false,
  eventTypeInfo: {
    eventTypeName: '',
    tabs: []
  }
};
